<template>
  <div class="page-container">
    <headerSection></headerSection>

    <!-- Hero Section -->
    <div class="hero-section">
      <div class="floating-ball ball-1"></div>
      <div class="floating-ball ball-2"></div>
      <div class="floating-ball ball-3"></div>

      <div class="container">
        <div class="hero-content">
          <div class="hero-icon-wrapper">
            <span class="hero-icon">🏆</span>
          </div>
          <h1 class="title-glow">{{ $t('rewards_page.title') }}</h1>
          <p class="hero-description" v-html="rewardDescription"></p>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="container main-content">
      <!-- Points Display -->
      <div class="points-display" v-if="user && user.coin">
        <div class="points-card">
          <span class="points-label">คะแนนของคุณ</span>
          <div class="points-value">
            <span class="points-icon">⭐</span>
            <span class="points-number">{{ user.coin }}</span>
          </div>
        </div>
      </div>

      <!-- Rewards Grid -->
      <div class="rewards-grid">
        <div
          class="reward-card"
          v-for="(item, index) in rewards"
          :key="index"
          :class="{ 'locked': checkLocked(item) }">
          <a href="#0" @click="conFirmRedeem(item)">
            <img class="reward-image" :src="item.image" :alt="item.name">

            <!-- Lock overlay if insufficient points -->
            <div class="lock-overlay" v-if="checkLocked(item)">
              <span class="lock-icon">🔒</span>
              <span class="lock-text">ต้องมีคะแนนเพียงพอ</span>
            </div>
          </a>
        </div>
      </div>

      <!-- Footer Info -->
      <div class="footer-info">
        <h2 class="footer-title"><a href="https://time2lucky.com">time2lucky</a>&nbsp;{{ $t('rewards_page.subtitle') }}</h2>
        <p class="footer-description">{{ $t('rewards_page.footer_description') }}</p>
      </div>
    </div>

    <footerSection></footerSection>
  </div>
</template>
  
<script>
import firebase from 'firebase/app'
import moment from 'moment'
const axios = require('axios').default
export default {
  name: 'Home',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  mounted () {
    const width = screen.width
    if(width <= 480)
      this.backgroundImage = require('../assets/images/Shiba-BG1.jpg')
    else
      this.backgroundImage = require('../assets/images/Shiba-BG1.jpg')
    // Bonn.boots.push(function() {
    //   setTimeout(function() {
    //     $('#bankInfoModal').modal('show');
    //   }, 500);
    // });
    this.$store.dispatch('user/getRewards').catch(err => { console.error(err) })
    this.loadRewardDescription()
    // this.checkAnoucement()
  },
  computed: {
    sites_credit () {
      return this.$store.state.user.sites_credit
    },
    user () {
      return this.$store.state.user.user
    },
    rewards () {
      return this.$store.state.user.rewards
    },
    swiper () {
      return this.$refs.mySwiper.$swiper
    },
    lastbonus () {
      return this.$store.state.user.lastbonus
    },
    rewardDescription () {
      const locale = this.$i18n ? this.$i18n.locale : 'th'
      if (this.rewardDescriptions && this.rewardDescriptions[locale] && this.rewardDescriptions[locale].trim() !== '') {
        return this.rewardDescriptions[locale]
      }
      return this.$t('rewards_page.description')
    }
  },
  data () {
    return {
      continueCheck: false,
      receiveAnounceMent: false,
      anoucement: {},
      balance: 0,
      fa_spin: false,
      backgroundImage: '',
      disabled: false,
      rewardDescriptions: null
    }
  },
  methods: {
    checkLocked (item) {
      if (!this.user || !this.user.key || !item) return true

      const availablePoints = Number(this.user.coin)
      const requiredPoints = Number(item.point)

      return !Number.isFinite(availablePoints) ||
        !Number.isFinite(requiredPoints) ||
        availablePoints < requiredPoints
    },
    checkStyle (item) {
      if (this.checkLocked(item)) {
        return 'border-radius:0px;-webkit-filter: grayscale(100%);filter: grayscale(100%);'
      }
    },
    async conFirmRedeem (item) {
      // ป้องกันการคลิกถ้า locked
      if (this.checkLocked(item)) {
        return
      }

      if (!this.disabled) {
        this.disabled = true
        this.$store.commit('user/SET_LOADING', true)
        this.$store.dispatch('user/moveCreditToWallet').finally(() => {
          this.$store.commit('user/SET_LOADING', false)
          if (this.user.coin && Number(this.user.coin) >= Number(item.point)) {
            this.$confirm(
              {
                message: this.getRedeemMessage(item),
                button: {
                  yes: this.$t('rewards_page.confirm'),
                  no: this.$t('rewards_page.cancel')
                },
                callback: confirm => {
                  if (confirm) {
                    this.$store.commit('user/SET_LOADING', true)
                    setTimeout(() => {
                      firebase.firestore().collection('redeem').add({
                        userkey: this.user.key,
                        code: this.user.code,
                        reward: item.key,
                        type: item.type,
                        credit: (item.credit) ? item.credit : '',
                        point: item.point,
                        status: false,
                        createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                      }).then((result) => {
                        axios({
                          method: 'post',
                          url: 'https://time2lucky.apifast.xyz/qmovetowallet/redeem',
                          data: {
                            code: this.user.code,
                            key: result.id
                          }
                        })
                        this.$store.commit('user/SET_LOADING', false)
                      })
                    }, Math.floor(Math.random() * 3000))
                  }
                }
              }
            )
          }
        }).catch(err => { console.error(err) })
        setTimeout(() => {
          this.disabled = false
        }, 2000)
      }
    },
    getRedeemMessage (item) {
      const turn = Number(item.turn) || 0
      const maxwithdraw = Number(item.maxwithdraw) || 0
      const locale = this.$i18n ? this.$i18n.locale : 'th'
      let line1, line3, turnText, withdrawText, separator
      if (locale === 'en') {
        line1 = `Do you want to use ${item.name} coins for games or casino only?`
        turnText = turn > 0 ? `Make a turnover of ${turn} times` : ''
        withdrawText = maxwithdraw > 0 ? `withdraw up to ${maxwithdraw} times` : ''
        separator = ', '
        line3 = 'Bonus cannot be withdrawn'
      } else if (locale === 'my') {
        line1 = `${item.name} အကြွေစေ့များဖြင့် ဂိမ်းနှင့် ကာစီနို အတွက်သာ ကစားလိုပါသလား?`
        turnText = turn > 0 ? `${turn} ဆ လည်ပတ်ရမည်` : ''
        withdrawText = maxwithdraw > 0 ? `အများဆုံး ${maxwithdraw} ဆ ထုတ်ယူနိုင်သည်` : ''
        separator = '၊ '
        line3 = 'ဘောနပ်စ်ကို ထုတ်ယူ၍မရပါ'
      } else {
        line1 = `ต้องการใช้เหรียญ ${item.name} เล่นเฉพาะเกม หรือคาสิโน`
        turnText = turn > 0 ? `ทำยอด ${turn} เท่า` : ''
        withdrawText = maxwithdraw > 0 ? `ถอนสูงสุด ${maxwithdraw} เท่า` : ''
        separator = ' '
        line3 = 'ไม่สามารถถอนโบนัสได้'
      }
      const parts = [turnText, withdrawText].filter(p => p)
      const lines = [line1]
      if (parts.length > 0) {
        lines.push(parts.join(separator))
        lines.push(line3)
      }
      return lines.join('\n')
    },
    async loadRewardDescription () {
      try {
        const snapshot = await firebase.database().ref('/condition/rewardDescription').once('value')
        if (snapshot.val()) this.rewardDescriptions = snapshot.val()
      } catch (e) { console.error(e) }
    },
    async redeem (item) {
      if (!this.checkLocked(item)) {
        if (item.type === 'credit') {
          this.$store.dispatch('user/refreshCreditAll').finally(res => {
            if (this.sites_credit.credit >= 5) {
              this.$swal({ icon: 'error', title: this.$t('rewards_page.title2'), html: this.$t('rewards_page.warning') })
            } else {
              this.conFirmRedeem(item)
            }
          })
        } else {
          this.conFirmRedeem(item)
        }
      }
    }
    // async moveCreditToWallet () {
    //   this.$store.commit('user/SET_LOADING', true)
    //   const user = this.getUserId()
    //   this.$store.dispatch('user/moveCreditToWallet').catch(err => { console.error(err) })
    //   this.$store.dispatch('user/getLastBonus', user).finally(res => {
    //     this.$store.commit('user/SET_LOADING', false)
    //     if (this.lastbonus.turncredit) {
    //       this.$store.commit('user/SET_ALERT_WITHDRAWALL', true)
    //     }
    //   }).catch(err => { console.error(err) })
    // },
  }
}
</script>
<style scoped>
/* Page Container */
.page-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #09030f 0%, #220735 50%, #09030f 100%);
  padding-bottom: 100px;
  font-family: 'Kanit', sans-serif;
}

/* Hero Section */
.hero-section {
  position: relative;
  padding: 80px 0 30px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(112, 32, 170, 0.1) 0%, transparent 100%);
}

.hero-content {
  position: relative;
  z-index: 0;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-icon-wrapper {
  display: inline-block;
  margin-bottom: 20px;
  animation: bounce 2s ease-in-out infinite;
}

.hero-icon {
  font-size: 64px;
  display: block;
  filter: drop-shadow(0 4px 15px rgba(183, 90, 255, 0.4));
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.title-glow {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  text-shadow:
    0 0 20px rgba(183, 90, 255, 0.5),
    0 0 40px rgba(112, 32, 170, 0.3),
    0 2px 4px rgba(0, 0, 0, 0.5);
}

.hero-description {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
}

/* Floating Balls */
.floating-ball {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  pointer-events: none;
  z-index: 1;
}

.floating-ball.ball-1 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #7020aa, #e0b5ff);
  top: -50px;
  left: -100px;
  animation: float1 6s ease-in-out infinite;
}

.floating-ball.ball-2 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #e0b5ff, #7020aa);
  top: 50%;
  right: -75px;
  animation: float2 8s ease-in-out infinite;
}

.floating-ball.ball-3 {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #220735, #7020aa);
  bottom: 20%;
  left: 10%;
  animation: float3 7s ease-in-out infinite;
}

@keyframes float1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(30px, 20px) rotate(180deg); }
}

@keyframes float2 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(-20px, 30px) rotate(-180deg); }
}

@keyframes float3 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(20px, -20px) rotate(180deg); }
}

/* Main Content */
.main-content {
  padding: 40px 20px;
}

/* Points Display */
.points-display {
  text-align: center;
  margin-bottom: 40px;
}

.points-card {
  background: linear-gradient(135deg, rgba(112, 32, 170, 0.2), rgba(183, 90, 255, 0.2));
  backdrop-filter: blur(10px);
  border: 2px solid rgba(183, 90, 255, 0.4);
  border-radius: 15px;
  padding: 20px 30px;
  display: inline-block;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(183, 90, 255, 0.2);
  text-align: center;
}

.points-label {
  display: block;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 10px;
}

.points-value {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.points-icon {
  font-size: 32px;
}

.points-number {
  font-size: 40px;
  font-weight: 700;
  color: #e0b5ff;
  text-shadow: 0 0 20px rgba(183, 90, 255, 0.5);
}

/* Rewards Grid */
.rewards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
  padding: 0 0 40px 0;
}

.reward-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(112, 32, 170, 0.2);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.reward-card:hover {
  transform: translateY(-5px);
  border-color: rgba(183, 90, 255, 0.4);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
}

.reward-card.locked {
  filter: grayscale(100%);
  opacity: 0.6;
}

.reward-card a {
  display: block;
  text-decoration: none;
}

.reward-image {
  width: 100%;
  height: auto;
  display: block;
}

.lock-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.lock-icon {
  font-size: 48px;
  margin-bottom: 10px;
}

.lock-text {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

/* Footer Info */
.footer-info {
  text-align: center;
  padding: 40px 20px;
}

.footer-title {
  font-size: 24px;
  font-weight: 700;
  color: #e0b5ff;
  margin-bottom: 15px;
}

.footer-title a {
  color: #e0b5ff;
  text-decoration: none;
}

.footer-title a:hover {
  text-decoration: underline;
}

.footer-description {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  max-width: 800px;
  margin: 0 auto;
}

/* Tablet */
@media screen and (max-width: 768px) {
  .hero-section {
    padding: 75px 0 25px;
  }

  .title-glow {
    font-size: 28px;
  }

  .hero-icon {
    font-size: 48px;
  }

  .floating-ball.ball-1 {
    width: 150px;
    height: 150px;
  }

  .floating-ball.ball-2 {
    width: 100px;
    height: 100px;
  }

  .floating-ball.ball-3 {
    width: 80px;
    height: 80px;
  }

  .rewards-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

/* Mobile */
@media screen and (max-width: 480px) {
  .hero-section {
    padding: 70px 0 20px;
  }

  .title-glow {
    font-size: 24px;
  }

  .hero-description {
    font-size: 14px;
  }

  .hero-icon {
    font-size: 40px;
  }

  .points-card {
    padding: 15px 20px;
  }

  .points-number {
    font-size: 32px;
  }

  .rewards-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .footer-title {
    font-size: 20px;
  }

  .footer-description {
    font-size: 14px;
  }
}
</style>
  
